import React from 'react'
import {
  Box,
  CircularProgress,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'

interface LoadingStateProps {
  message?: string
  size?: number
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Cargando datos...',
  size = 40
}) => {
  const styles = useStyles()

  return (
    <Box className={styles.container}>
      <Box className={styles.content}>
        <CircularProgress size={size} className={styles.spinner} />
        <Typography variant="body1" className={styles.message}>
          {message}
        </Typography>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: theme.spacing(4)
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center'
  },
  spinner: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main
  },
  message: {
    color: theme.palette.grey[600]
  }
}))